<template lang="pug">

.pp-item(
    :class="[{'pp-item--scored': isScored},{'pp-item--visitor': isVisitor}, {'pp-item--global': isMatchPlay}]"
    :data-aos="aosDirection"
    data-aos-once="true"
    )
    .pp-item-glo
        .ge-match-time
            span.ge-match-time-info {{ getPeriodStr(play.periodo) }}
            span.ge-match-time-sec {{play.crono}}
    .pp-item-mes
        .pp-item-mes-portrait(v-if="isPlayerPlay || isTeamPlay")
            img.pp-item-mes-portrait__img(:src="isPlayerPlay ? play.player.img : (isVisitor ? visitingImage : localImage)", :alt="play.player.name")
            span.pp-item-mes-portrait__name(v-if="isPlayerPlay") {{ play.player.name }}
        .pp-item-mes-info
            .pp-item-mes-info-text 
                span.pp-item-mes-info-text__desc {{playText(play)}}
                span.pp-item-mes-info-text__stats(v-if="playStats(play)") {{playStats(play)}}
            .pp-item-mes-info-icon(v-if="!isMatchPlay")
                img(v-if="!hideIcon && playIcon" :src="playIcon")
        .pp-item-mes-score(v-if="!isMatchPlay")
            span.pp-item-mes-score__local {{play.puntosLocal}}
            span.pp-item-mes-score__visitor {{play.puntosVisitante}}
        
        img.pp-item-mes__team(v-if="isPlayerPlay" :src="isVisitor ? this.$store.state.match.visitorImage : this.$store.state.match.localImage" :alt="$store.state.match.localShortName")

</template>

<script>

export default {
    name: "Play",
    props: {
        play: Object
    },
    computed: {
        playIcon() {
            if(this.play.idPlayByPlayType == 93 || this.play.idPlayByPlayType == 100)
                return ("/play-by-play/tiro-anotado-2-icono.png")

            else if (this.play.idPlayByPlayType == 94)
                return ("/play-by-play/tiro-anotado-3-icono.png")

            else if (this.play.idPlayByPlayType == 92)
                return ("/play-by-play/tiro-anotado-1-icono.png")

            else if (this.play.idPlayByPlayType == 112 || this.play.idPlayByPlayType == 599)
                return ("/play-by-play/sustitucion-entra-icono.png")

            else if (this.play.idPlayByPlayType == 115)
                return ("/play-by-play/sustitucion-sale-icono.png")

            else if (
                (this.play.idPlayByPlayType >= 96 && this.play.idPlayByPlayType <= 98) ||
                (this.play.idPlayByPlayType == 533)
                )
                return ("/play-by-play/tiro-fallado-icono.png")

            else if (
                        (this.play.idPlayByPlayType == 104) || 
                        (this.play.idPlayByPlayType == 101) || 
                        (this.play.idPlayByPlayType == 103) ||
                        (this.play.idPlayByPlayType == 130 || this.play.idPlayByPlayType == 135)
                    )
                return ("/play-by-play/recuperacion-icono.png")

            else if (this.play.idPlayByPlayType == 107 || this.play.idPlayByPlayType == 108)
                return ("/play-by-play/asistencia-icono.png")

            else if (this.play.idPlayByPlayType == 106)
                return ("/play-by-play/pelota-perdida-icono.png")

            else if (this.play.idPlayByPlayType == 102 || this.play.idPlayByPlayType == 105)
                return ("/play-by-play/tapon-icono.png")

            else if (this.play.idPlayByPlayType == 113)
                return ("/play-by-play/tiempo-muerto-icono.png")
            else if (
                        this.play.idPlayByPlayType == 109 ||
                        this.play.idPlayByPlayType == 110 ||
                        (this.play.idPlayByPlayType >= 159 && this.play.idPlayByPlayType <= 169) || 
                        (this.play.idPlayByPlayType >= 537 && this.play.idPlayByPlayType <= 547) ||
                        (this.play.idPlayByPlayType >= 172 && this.play.idPlayByPlayType <= 177)
                    )
                return ("/play-by-play/falta-icono.png")
            return ("")
            
        },
        hideIcon() {
            let hideIconList = [
                122,
                121,
                116,
                123,
                118,
                405,
                119,
                552,
                553,
                554,
                555,
                556,
                175,
                600,
                598
            ]
            return (hideIconList.indexOf(this.$props.play.idPlayByPlayType) >= 0 )
        },
        localImage() {
            return this.$store.state.match.localImage
        },
        visitingImage() {
            return this.$store.state.match.visitorImage
        },
        isTeamPlay() { 
            return (this.$props.play.tipo.descripcion == "team")
        },
        isMatchPlay() {
            return (this.$props.play.tipo.descripcion == "match")
        },
        isPlayerPlay() {
            return (this.$props.play.tipo.descripcion == "player")
        },
        isVisitor() {
            return (!this.$props.play.local && this.$props.play.local != null)
        },
        isScored() {
            return ([92,93,94,100].indexOf(this.$props.play.idPlayByPlayType) >= 0)
        },
        // COMBINED WITH overflow: hidden
        aosDirection() {
            if (this.isVisitor) {
                return 'fade-left'
            } else if (this.isMatchPlay) {
                return 'fade-up'
            } else {
                return 'fade-right'
            }
        }
        // ELSE
        // aosDirection() {
        //     return 'fade-up'
        // }
    },
    methods: {
        playAccumulated(play) {
            try {
                if (play.statistics) {
                    let stats = null
                    if (play.idPlayByPlayType == 92) {
                        stats = `${play.statistics.points} ${this.$i18n.t("puntos")}, ${play.statistics['1pt_success']}/${play.statistics['1pt_tried']} ${this.$i18n.t("t1")}`
                    } else if (play.idPlayByPlayType == 93 || play.idPlayByPlayType == 100) {
                        stats = `${play.statistics.points} ${this.$i18n.t("puntos")}, ${play.statistics['2pt_success']}/${play.statistics['2pt_tried']} ${this.$i18n.t("t2")}`
                    } else if (play.idPlayByPlayType == 94) {
                        stats = `${play.statistics.points} ${this.$i18n.t("puntos")}, ${play.statistics['3pt_success']}/${play.statistics['3pt_tried']} ${this.$i18n.t("t3")}`
                    } else if (play.idPlayByPlayType == 96) {
                        stats = `${play.statistics['1pt_success']}/${play.statistics['1pt_tried']} ${this.$i18n.t("t1")}`
                    } else if (play.idPlayByPlayType == 97 || play.idPlayByPlayType == 533) {
                        stats = `${play.statistics['2pt_success']}/${play.statistics['2pt_tried']} ${this.$i18n.t("t2")}`
                    } else if (play.idPlayByPlayType == 98) {
                        stats = `${play.statistics['3pt_success']}/${play.statistics['3pt_tried']} ${this.$i18n.t("t3")}`
                    } else if (play.idPlayByPlayType == 101 || play.idPlayByPlayType == 104) {
                        stats = `${play.statistics['total_rebound']} ${this.$i18n.t("rt")}`
                    } else if (play.idPlayByPlayType == 102) {
                        stats = `${play.statistics['blocks']} ${this.$i18n.t("tc")}`
                    } else if (play.idPlayByPlayType == 103) {
                        stats = `${play.statistics['steals']} ${this.$i18n.t("br")}`
                    } else if (play.idPlayByPlayType == 106) {
                        stats = `${play.statistics['turnovers']} ${this.$i18n.t("bp")}`
                    } else if (play.idPlayByPlayType == 107 || play.idPlayByPlayType == 108 || play.idPlayByPlayType == 119) {
                        stats = `${play.statistics['asis']} ${this.$i18n.t("asis")}`
                    } else if ([109, 159, 160, 161, 162, 165, 166, 167, 172].includes(play.idPlayByPlayType)) {
                        stats = `${play.statistics['personal_fouls']} ${this.$i18n.t("fp")}`
                    } else if (play.idPlayByPlayType == 110) {
                        stats = `${play.statistics['received_fouls']} ${this.$i18n.t("fr")}`
                    }
                    return stats
                }
            } catch {
                return null
            }
        },
        // playText(play) {
        //     let description =  this.translatePlay(play.playByPlayDescripcion)
        //     let stats = this.playAccumulated(play)
        //     if (stats) {
        //         return `${description} (${stats})`
        //     }
        //     return description
        // },


        playStats(play){
            let stats = this.playAccumulated(play)
            if (stats){
                return `(${stats})`
            }
            return false
        },

        playText(play) {
            return this.translatePlay(play.playByPlayDescripcion)
        },
        getPeriodStr(period) {
            if (period < 5) {
                return period + this.$i18n.t("Q");
            } else {
                return `${this.$i18n.t("OT")}${period - 4}`;
            }
        },
        translatePlay(description) {
            return this.$i18n.t(description)
        }
    },
    created() {
    },
}

</script>